import {createRecipePlan} from './recipe-process.js';

export const RECIPE_PLAN_CACHE_ENTITY_TYPE='recipe_plan_cache';

function required(value,label,max=160){
  const text=String(value??'').trim();
  if(!text)throw new TypeError(label+' is required');
  if(text.length>max)throw new TypeError(label+' is too long');
  return text;
}

function clean(record){
  const copy={...record};
  delete copy.key;
  delete copy.entityType;
  return copy;
}

export function createRecipePlanCache({repository,now=()=>new Date().toISOString()}={}){
  if(!repository?.get||!repository?.list||!repository?.put)throw new TypeError('repository is required');

  async function put(plan,{cachedForUserId=null,guidance={}}={}){
    const value=createRecipePlan(plan);
    const privateRecipe=value.recipe.visibility==='private';
    const owner=privateRecipe?required(cachedForUserId,'cachedForUserId',128):(cachedForUserId?required(cachedForUserId,'cachedForUserId',128):null);
    if(privateRecipe&&value.recipe.authorUserId!==owner){
      throw new TypeError('Private Recipe cache owner mismatch');
    }
    return repository.put(RECIPE_PLAN_CACHE_ENTITY_TYPE,{
      id:value.recipe.id,
      plan:value,
      cachedForUserId:owner,
      guidance:guidance&&typeof guidance==='object'&&!Array.isArray(guidance)?guidance:{},
      cachedAt:now(),
      updatedAt:value.recipe.updatedAt
    });
  }

  async function get(id,{userId=null}={}){
    const row=await repository.get(RECIPE_PLAN_CACHE_ENTITY_TYPE,required(id,'id',128));
    if(!row)return null;
    const value=createRecipePlan(row.plan);
    if(value.recipe.visibility==='private'){
      const owner=String(userId??'').trim();
      if(!owner||row.cachedForUserId!==owner||value.recipe.authorUserId!==owner)return null;
    }
    return Object.freeze({...clean(row),plan:value});
  }

  async function list({userId=null}={}){
    const owner=String(userId??'').trim();
    const rows=await repository.list(RECIPE_PLAN_CACHE_ENTITY_TYPE);
    const result=[];
    for(const row of rows||[]){
      try{
        const value=createRecipePlan(row.plan);
        if(value.recipe.visibility==='private'){
          if(!owner||row.cachedForUserId!==owner||value.recipe.authorUserId!==owner)continue;
        }
        result.push(Object.freeze({...clean(row),plan:value}));
      }catch{}
    }
    return Object.freeze(result.sort((a,b)=>
      String(b.updatedAt||b.cachedAt||'').localeCompare(String(a.updatedAt||a.cachedAt||''))
      ||String(a.id).localeCompare(String(b.id))
    ));
  }

  return Object.freeze({put,get,list});
}
